import { render, staticRenderFns } from "./WebsiteStep.vue?vue&type=template&id=deca6b64&scoped=true"
import script from "./WebsiteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WebsiteStep.vue?vue&type=style&index=0&id=deca6b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deca6b64",
  null
  
)

export default component.exports